// extracted by mini-css-extract-plugin
export default {"FooterContainer":"Footer_FooterContainer__rO-b7","Link":"Footer_Link__XCdwn"};